import React, { useEffect, useState } from 'react'

import ScoreGridItem from '@components/myScores/ScoresView/ScoreGridView/ScoreGridItem'
import { ScoreGridOptions } from '@components/myScores/utils/types'
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  rectSortingStrategy,
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import Product from '@models/Product'
import Score from '@models/Score'

interface Props {
  scores: (Score | Product)[]
  options?: ScoreGridOptions
}
const ScoreGridView: React.FC<Props> = ({ scores, options }) => {
  const [items, setItems] = useState(scores)
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event
    if (active.id === over?.id) return

    setItems((prevItems) => {
      const oldIdx = prevItems.findIndex((item) => item.id === active.id)
      const newIdx = prevItems.findIndex((item) => item.id === over?.id)

      if (typeof options?.onSort === 'function') {
        options.onSort(oldIdx, newIdx)
      }
      return arrayMove(prevItems, oldIdx, newIdx)
    })
  }

  // Update scores if we get an external update
  useEffect(() => {
    setItems(scores)
  }, [scores])

  return (
    <div
      className="grid gap-2.5"
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(min(${
          options?.minGridWidth ?? 440
        }px, 100%), 1fr))`,
      }}>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={items.map((item) => item.id)} strategy={rectSortingStrategy}>
          {items.map((score) => (
            <ScoreGridItem score={score} options={options} key={`score-${score.id}`} />
          ))}
        </SortableContext>
      </DndContext>
    </div>
  )
}

export default ScoreGridView
